export const DnsGossip  = "dns";
export const SeedGossip = "seed";

